export default "__VITE_ASSET__CpgTBnwU__"